import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NotificationService } from './notification.service';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from '@app/_services';
import { HasUnsavedChanges } from '@app/_guards/unsavedChanges.guard';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.less']
})
export class NotificationComponent implements OnInit, HasUnsavedChanges {
  moduleDetails: any = {};
  moduleType;
  notificationConfigData: any = [];
  entityClassName;
  pageHasUpdate: any = false;

  constructor(private route: ActivatedRoute, private notificationService: NotificationService, private toastr: ToastrService,
              private AuthService: AuthenticationService) { }

  ngOnInit() {
    this.moduleType = this.route.snapshot.data['type'];
    this.moduleDetails = this.route.snapshot.data['details'].response;
    this.AuthService.getUserRoleByProject(this.moduleDetails.role); /* Role */

    /* If endpoint page */
    if (this.moduleType === 'ENDPOINT') this.entityClassName = "com.adobe.relay.data.domain.EndPoint";

    /* If testcase page */
    if (this.moduleType === 'TESTCASE') this.entityClassName = "com.adobe.relay.data.domain.TestCase";

    /* If testsuite page */
    if (this.moduleType === 'TESTSUITE') this.entityClassName = "com.adobe.relay.data.domain.TestSuite";

    /* If mastersuite page */
    if (this.moduleType === 'MASTERSUITE') this.entityClassName = "com.adobe.relay.data.domain.MasterSuite";
    this.getNotifConfig();
  }

  hasUnsavedChanges(): boolean {
    let condition = this.pageHasUpdate;
    return condition;
  }

  getNotifConfig() {
    this.notificationService.getNotification(this.moduleDetails['id']).pipe().subscribe(data => {
      this.notificationConfigData = data.response;
      this.notificationConfigData.subjectClass = this.entityClassName;
      this.notificationConfigData.subjectId = this.moduleDetails['id'];
    });
  }

  addNewEmailId(obj) {
    if (!obj.emailIds || obj.emailIds == null) {
      obj.emailIds = [];
    }

    /* Error handling */
    var errorFound = 0;
    obj.emailIds.forEach(function (val: any) {
      if (val === obj.newEmailId) {
        errorFound++;
      }
    });

    if (errorFound > 0) {
      this.toastr.error('Duplicate email id !!!');
      return;
    }

    let regex = new RegExp('.+?(?=@)([^\s]+)');
    if (!regex.test(obj.newEmailId)) {
      this.toastr.error('Invalid email address !!!');
      return;
    }

    obj.emailIds.push(obj.newEmailId);
    delete obj.newEmailId;
  }

  saveEmailId(obj) {
    let dataObj = JSON.parse(JSON.stringify(obj));
    let count = 0;
    let msg = "";

    obj.notificationConfigDto.notificationTypeConfigDtos.forEach(function (val) {
      if (val.newEmailId) {
        count++;
        msg = "Please add email to list and then save !!!";
      }
    });

    if (count > 0) {
      this.toastr.error(msg);
      return;
    }

    obj.notificationConfigDto.notificationTypeConfigDtos.forEach(function (val) {
      delete val.newEmailId;
    });

    delete dataObj.notificationTypeConfigDtos;

    obj.subjectClass = this.entityClassName;

    if (dataObj.id == null) {  /* Save */
      this.notificationService.saveNotification(obj).subscribe(data => {
        if (data.code === 200) {
          this.getNotifConfig();
          this.toastr.success(data.message);
          this.pageHasUpdate = false;
        } else {
          this.toastr.error(data.message);
        }
      });
    } else { /* Update */
      this.notificationService.updateNotification(obj).subscribe(data => {
        if (data.code === 200) {
          this.getNotifConfig();
          this.toastr.success(data.message);
          this.pageHasUpdate = false;
        } else {
          this.toastr.error(data.message);
        }
      });
    }
  }

  openHelpLink() {
    window.open("https://wiki.corp.adobe.com/display/Relay/Custom+Subject", '_blank');
  }
}


